/**
 * tld-search  directive.
 * params: tld-search
 */
App.directive('tldSearch', function($rootScope, domainService){
	return {
		require: 'ngModel',
		restrict: 'A',
		scope: {
			searchFunction: '&tldSearch',
			ngModel: '&'
		},
		link: function(scope,el,attrs,ctrl) {
			//initialize popover
			var validDomainRegex = '^[a-zA-Z0-9\\-]+\\..+$',
				validDomainRegexNoTld = '^[a-zA-Z0-9\\-\\s]+$',
				validDomainCo = '^[a-zA-Z0-9\\-]+\\.co$',
				validDomainCoXyz = '^[a-zA-Z0-9\\-]+\\.(co|xyz)?$',
				validationRegex = '',
				model = attrs.ngModel,
				searchFunction = scope.searchFunction();

			//watch for scope changes on the input model
			$rootScope.$watch(attrs.ngModel, function(viewValue) {
				
				void 0;

				$rootScope.showAlerts = false;
				$rootScope.selectedDomain = null;
				$rootScope.domainError = false;
				$rootScope.showTitle = '';
				$rootScope.showSubtitle = '';

				if( typeof viewValue != 'undefined' )
				{
					if(viewValue.length === 0)
					{
						$rootScope.formDomain.$setPristine();
					}

					if( viewValue.indexOf(".") != -1 )
					{
						//first check what type of bundle that way we can switch regex
						if($rootScope.currentBundle == "myo")
						{
							//whoa whoa buddy, now we need to validate with a period
							validationRegex = validDomainRegex;
							//remove invalid characters
							viewValue = viewValue.replace(/[^a-zA-Z0-9-\\.]/ig,'');
						} else {
                            var exts = $rootScope.anytld.join('|');
                            var regreplace = new RegExp('[^a-zA-Z0-9-\\.('+exts+')?$]', 'ig');
                            validationRegex = '^[a-zA-Z0-9\\-]+\\.('+exts+')?$';

                            //remove invalid characters
							viewValue = viewValue.replace(regreplace,'');
						}
					} else {
						//ok fine just validate domain without a period
						validationRegex = validDomainRegexNoTld;
						//remove invalid characters, except spaces
						viewValue = viewValue.replace(/[^a-zA-Z0-9- ]/ig,'');
					}

					//create regex
					var regex = new RegExp(validationRegex,'ig');

					//update scope model yo
                    viewValue = viewValue.replace('www.','');
					// i really hate doing this, because its specific and not dynamic, but here it goes:
					$rootScope.formData.domain = viewValue;

					//validate it
					if (regex.test(viewValue)) {
						// it is valid
						ctrl.$setValidity('validUrl', true);
					} else {
						// it is invalid
						ctrl.$setValidity('validUrl', false);
						domainService.stop();
					}
					
					//finally, check if viewvalue length >= 2
					searchFunction(true);
				} else {
					//cancel current call
					domainService.stop();
				}

			});
		}
	}
});
